var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.742,
    height: 48,
    viewBox: "0 0 43.742 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}.b{fill:#20253a;}.c{fill:#fdfefe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(648 -4434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-648 4434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.473,222.55a12.75,12.75,0,0,1,6.747-11.281h0a5.583,5.583,0,0,1,.83-.387A14.979,14.979,0,0,0,39.69,209.5h-4.2a15.329,15.329,0,0,0-15.373,15.318v3.871a1.629,1.629,0,0,0,1.659,1.659H41.128a9.4,9.4,0,0,1-.553-.774A12.484,12.484,0,0,1,38.473,222.55Z",
    transform: "translate(-20.114 -187.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.253,20.35a10.217,10.217,0,0,0,7.189-2.986,10.146,10.146,0,0,0,0-14.378,10.146,10.146,0,0,0-14.378,0,10.316,10.316,0,0,0-2.986,7.189A10.219,10.219,0,0,0,99.253,20.35Z",
    transform: "translate(-81.778 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M203.729,211.592a13.1,13.1,0,0,0-5.2,1.106c-.276.111-.553.276-.83.387h0a12.879,12.879,0,0,0-6.747,11.281,12.484,12.484,0,0,0,2.1,7.023,6.713,6.713,0,0,0,.553.774,12.811,12.811,0,1,0,10.12-20.571Z",
    transform: "translate(-172.872 -189.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M260.513,284.6v-2.931h2.931a1.659,1.659,0,1,0,0-3.318h-2.931v-2.931a1.659,1.659,0,0,0-3.318,0v2.931h-2.931a1.659,1.659,0,0,0,0,3.318h2.931V284.6a1.659,1.659,0,0,0,3.318,0Z",
    transform: "translate(-227.997 -244.787)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.af2eb3e17b01b626bdc1d25396ea8f68.svg";
export { ForwardRef as ReactComponent };